import { useMemo } from 'react';

import { useGetLanguages } from '@vimeo/gctl-api/hooks/useLanguages';

export function useLanguageNamesForAudiotracks() {
  const { data: languageResp } = useGetLanguages({
    query: { filter: 'audiotracks' }, // Return languages that can be used for audio tracks.
    select: ['code', 'name'],
  });

  const languageCodeToNameMap: { [key: string]: string } = useMemo(
    () =>
      languageResp?.data?.reduce((acc, lang) => {
        (acc as any)[lang.code] = lang.name;
        return acc;
      }, {}) || {},
    [languageResp],
  );

  return {
    languageCodeToNameMap,
  };
}
